// extracted by mini-css-extract-plugin
module.exports = {"hero":"WorkspaceHero_hero__ZMtsZ","tabs":"WorkspaceHero_tabs__WcsDh","imageError":"WorkspaceHero_imageError__XeldZ"};